import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ScrollTopHistory } from './scroll-top-history';

export function provideDfBrowser(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(ScrollTopHistory).appInitialize();
        })
    ]);
}
